import { redirect } from "@tanstack/react-router";
import { DEFAULT_MAX_DISTANCE_MILES } from "@wags/discovery/pure.ts";
import {
    type DiscoverySearch,
    DiscoverySearchSchema,
} from "../explore/discoveryRoute.contract.ts";
import { resolveRouteApproximateLocation } from "@/features/viewer-location";
import type { InitialGeoContext } from "@/features/viewer-location";
import { seoMeta } from "@/lib/ui/seo";

export const browseDogsExploreRoute = {
    validateSearch: DiscoverySearchSchema,
    ssr: "data-only" as const,
    beforeLoad: async ({
        context,
        search,
    }: {
        context: InitialGeoContext;
        search: DiscoverySearch;
    }) => {
        const hasLocation = search.lat != null && search.lng != null;
        const locationFromEstimate = !hasLocation
            ? await resolveRouteApproximateLocation(context)
            : null;

        const shouldSetDefaultDistance =
            search.maxDistanceMiles === undefined &&
            (hasLocation || locationFromEstimate !== null);

        if (shouldSetDefaultDistance || locationFromEstimate) {
            throw redirect({
                to: "/explore",
                search: {
                    ...search,
                    maxDistanceMiles: shouldSetDefaultDistance
                        ? DEFAULT_MAX_DISTANCE_MILES
                        : search.maxDistanceMiles,
                    lat: locationFromEstimate?.lat ?? search.lat,
                    lng: locationFromEstimate?.lng ?? search.lng,
                },
                replace: true,
            });
        }
    },
    head: () => ({
        ...seoMeta({
            title: "Explore — Wags",
            description:
                "Most popular puppies near you. Tap into the feed and start scrolling.",
            url: "/explore",
        }),
    }),
};
